import React from 'react';
import { Space, App } from 'antd'
import {useBusinessNumAuditMutation,useBusinessNumAuditCancelMutation } from '../../store/ReactWebSiteApi';

function LedgerAudit(props) {
    const { message } = App.useApp();
    //审核台账-----------------------------------------------------------------------------------------------------------------------------审核台账
    const [submitAudit] = useBusinessNumAuditMutation();
    const [submitAuditCancle] = useBusinessNumAuditCancelMutation();
    return (
        <Space>
            {(!props.ebn_audit_ctime && props.ebn_state==='2' && !localStorage.getItem('ess_menu_id').includes('91')) &&<a  
                onClick={() => {
                    submitAudit({
                        ebn_id:props.ebn_id,
                        ebn_audit_uid:localStorage.getItem('eu_id'),
                        ebn_audit_uname:localStorage.getItem('eu_name'),
                        rankNum:'1',
                    }).then((res) => {
                        //console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('1级审核成功！') 
                        }
                        if (res.data.Status === 'fail') {
                            message.error('1级审核失败！'+res.data.Message)
                        }
                    })
                }}>1级审核</a>}
            {(props.ebn_audit_ctime && !props.ebn_audit2_ctime && props.ebn_state==='2' && !localStorage.getItem('ess_menu_id').includes('91')) && <a 
                            onClick={() => {
                                submitAuditCancle({
                                    ebn_id:props.ebn_id,
                                    rankNum:'1',
                                }).then((res) => {
                                    //console.log(res);
                                    if (res.data.Status === 'success') {
                                        message.success('取消1级审核成功！')  
                                    }
                                    if (res.data.Status === 'fail') {
                                        message.error('取消1级审核失败！'+res.data.Message)
                                    }
                                })
                            }}>取消1级审核</a>}
            {(props.ebn_audit_ctime && !props.ebn_audit2_ctime && props.ebn_state==='2' && !localStorage.getItem('ess_menu_id').includes('92')) &&<a  
                onClick={() => {
                    submitAudit({
                        ebn_id:props.ebn_id,
                        ebn_audit_uid:localStorage.getItem('eu_id'),
                        ebn_audit_uname:localStorage.getItem('eu_name'),
                        rankNum:'2',
                    }).then((res) => {
                        //console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('2级审核成功！') 
                        }
                        if (res.data.Status === 'fail') {
                            message.error('2级审核失败！'+res.data.Message)
                        }
                    })
                }}>2级审核</a>}
            {(props.ebn_audit2_ctime && !props.ebn_audit3_ctime && props.ebn_state==='2' && !localStorage.getItem('ess_menu_id').includes('92')) && <a 
                            onClick={() => {
                                submitAuditCancle({
                                    ebn_id:props.ebn_id,
                                    rankNum:'2',
                                }).then((res) => {
                                    //console.log(res);
                                    if (res.data.Status === 'success') {
                                        message.success('取消2级审核成功！')  
                                    }
                                    if (res.data.Status === 'fail') {
                                        message.error('取消2级审核失败！'+res.data.Message)
                                    }
                                })
                            }}>取消2级审核</a>}
            {(props.ebn_audit2_ctime && !props.ebn_audit3_ctime && props.ebn_state==='2' && !localStorage.getItem('ess_menu_id').includes('92')) &&<a  
                onClick={() => {
                    submitAudit({
                        ebn_id:props.ebn_id,
                        ebn_audit_uid:localStorage.getItem('eu_id'),
                        ebn_audit_uname:localStorage.getItem('eu_name'),
                        rankNum:'3',
                    }).then((res) => {
                        //console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('3级审核成功！') 
                        }
                        if (res.data.Status === 'fail') {
                            message.error('3级审核失败！'+res.data.Message)
                        }
                    })
                }}>3级审核</a>}
            {(props.ebn_audit3_ctime && !props.ebn_audit4_ctime && props.ebn_state==='2' && !localStorage.getItem('ess_menu_id').includes('92')) && <a 
                            onClick={() => {
                                submitAuditCancle({
                                    ebn_id:props.ebn_id,
                                    rankNum:'3',
                                }).then((res) => {
                                    //console.log(res);
                                    if (res.data.Status === 'success') {
                                        message.success('取消3级审核成功！')  
                                    }
                                    if (res.data.Status === 'fail') {
                                        message.error('取消3级审核失败！'+res.data.Message)
                                    }
                                })
                            }}>取消3级审核</a>}
            {(props.ebn_audit3_ctime && !props.ebn_audit4_ctime && props.ebn_state==='2' && !localStorage.getItem('ess_menu_id').includes('92')) &&<a  
                onClick={() => {
                    submitAudit({
                        ebn_id:props.ebn_id,
                        ebn_audit_uid:localStorage.getItem('eu_id'),
                        ebn_audit_uname:localStorage.getItem('eu_name'),
                        rankNum:'4',
                    }).then((res) => {
                        //console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('4级审核成功！') 
                        }
                        if (res.data.Status === 'fail') {
                            message.error('4级审核失败！'+res.data.Message)
                        }
                    })
                }}>4级审核</a>}
            {(props.ebn_audit4_ctime  && props.ebn_state==='2' && !localStorage.getItem('ess_menu_id').includes('92')) && <a 
                            onClick={() => {
                                submitAuditCancle({
                                    ebn_id:props.ebn_id,
                                    rankNum:'4',
                                }).then((res) => {
                                    //console.log(res);
                                    if (res.data.Status === 'success') {
                                        message.success('取消4级审核成功！')  
                                    }
                                    if (res.data.Status === 'fail') {
                                        message.error('取消4级审核失败！'+res.data.Message)
                                    }
                                })
                            }}>取消4级审核</a>}
            
        </Space>
    )
}

export default LedgerAudit